import { useUser } from "@/queries/user"
import { type LoanProfileType } from "@/generated/graphql"

export const isUserQualifiedForContactLink = (loanProfile: LoanProfileType) => {
  // This is temporary until we get every server and client converted.
  // We can't fix Zion until all clients have this new code test.
  // Since all "values" in the enum starts with "A_" we use the old test here.
  // Remove when zion has the change in prod.
  if (!loanProfile.propertiesFlipped?.startsWith("A")) {
    return (
      loanProfile.propertiesFlipped !== "A_0" &&
      loanProfile.rentalsOwned !== "A_0" &&
      loanProfile.creditScore !== "BELOW_640" &&
      loanProfile.cashAvailable !== "A_0_25"
    )
  } else {
    return (
      loanProfile.propertiesFlipped !== "0" &&
      loanProfile.rentalsOwned !== "0" &&
      loanProfile.creditScore?.toLowerCase()! !== "below-640" &&
      loanProfile.cashAvailable !== "0-25"
    )
  }
}

export const useUserQualifiedForContactLink = () => {
  const { data: user } = useUser()
  const loanProfile = user?.me?.loanProfile

  return loanProfile ? isUserQualifiedForContactLink(loanProfile) : true // no loan profile show the link
}
